import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type AgentResponse, getAgent2 } from '@generated/search-bff';

/**
 * Fetch detailed agent information by its id (UUID) using the `/api/v1/masterdata/agent/{agentId}` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/agent/getAgentById Search API Documentation}
 */
export async function getAgentById(agentId: string, apiConfig: ApiConfig): Promise<ApiResult<AgentResponse>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'getAgent2');

  try {
    const agent = await getAgent2(agentId, _apiConfig);

    return {
      status: 'success',
      data: agent,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
